var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.57 15.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #262451;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RESPOPNSIVE_MOVIL",
    "data-name": "RESPOPNSIVE MOVIL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOME_PAGE",
    "data-name": "HOME PAGE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.79,1.28l.23,1.16c.51,2.57,2.34,4.68,4.81,5.55h0,0c-2.47.87-4.29,2.98-4.81,5.55l-.23,1.16-.23-1.16c-.51-2.57-2.34-4.68-4.81-5.55h0,0c2.47-.87,4.29-2.98,4.81-5.55l.23-1.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Star);
export default __webpack_public_path__ + "static/media/4star.e8a460ad8f5d427f8001f43c3eeecc02.svg";
export { ForwardRef as ReactComponent };